export default __webpack_public_path__ + "static/media/Pushchair.c92a26ba.png";